import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import MemberReportConfig from '../../MemberReportConfig/components';
import Home from '../../RFMConfig/components/Home';
import HierarchyRFMConfig from '../../HierarchyRFMConfig/components/HierarchyRFMConfig';

const CustomerCubeSettings = lazy(
  () => import('../components/CustomerCubeSettings')
);
const RFMConfig = lazy(() => import('../../RFMConfig/components/RFMConfig'));
const CasaFieldConfig = lazy(
  () => import('../../CasaFields/components/TenantFields')
);
const FestivalSettings = lazy(
  () => import('../../FestivalSettings/components/FestivalSettings')
);
const KPIReportConfig = lazy(
  () => import('../../KPIConfig/components/KPIConfig'));
const ProductRecommendationSettings = lazy(
  () =>
    import(
      '../../ProductRecommendationSettings/components/ProductRecommendationSettings'
    )
);

const StoreSalesForecastSettings = lazy(
  () => import("../../StorePrediction/components/StoreSalesForecastSettings/StoreSalesForecastSettings")
)

const ExecutiveSummarySettings = lazy(
  () => import("../../ExecutiveSummarySettings/components/ExecutiveSummarySettings")
)

const BillTransformer = lazy(
  () => import('../../PosIntegrations/components/BillTransformer/BillTransformer')
)

const customerCubeSettingsRoute: RouteObject = {
  path: '/settings/module/customer-cube',
  element: <CustomerCubeSettings />,
  children: [
    {
      index: true,
      element: <Navigate to="./rfm" replace />,
    },
    {
      path: "rfm",
      element: <Home />,
      children: [
        {
          index: true,
          element: <RFMConfig />,
        },
        {
          path: 'product-hierarchy',
          element: <HierarchyRFMConfig />,
        }
      ]
    },
    {
      path: 'field-mapping',
      element: <CasaFieldConfig />,
    },
    {
      path: 'festival-settings',
      element: <FestivalSettings />,
    },
    {  
      path: 'kpi-report',
      element: <KPIReportConfig />,
    },
    {
      path: 'member-report',
      element:<MemberReportConfig/>
    },
    {
      path: 'product-recommendation',
      element: <ProductRecommendationSettings />,
    },
    {
      path: 'store-target',
      element: <StoreSalesForecastSettings />
    },
    {
      path: 'executive-summary',
      element: <ExecutiveSummarySettings />
    },
    {
      path: 'bill-transformer',
      element: <BillTransformer />
    }
  ],
};

export default customerCubeSettingsRoute;
